import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  ul: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
  },
  pageItem: {
    color: theme.palette.text.primary,
    // width: 52,
    height: 52,
  },
  shiftButton: {
    background: theme.palette.background.paper,
    borderColor: '#ABAFB3',
    color: theme.palette.grey['400'],
    width: 91,
    '&:hover': {
      borderColor: '#ABAFB3',
    },
  },
  selected: {
    // width: 52,

    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.contrastText,
    },
  },
  next: {
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? `0 16px 0 0` : `0 0 0 16px`,
  },
  previous: {
    margin: ({ direction }: LayoutDirection) => direction === 'rtl' ? `0 0 0 16px` : `0 16px 0 0`,
  },
}));
